import { Routes } from '@angular/router';
import { GwrcontainerComponent } from './gwrcontainer/gwrcontainer.component';
import { GwrGebaeudeSucheComponent } from './gwr-gebaeude/gwr-gebaeude-suche/gwr-gebaeude-suche.component';
import { GwrGebaeudeSearchResultComponent } from './gwr-gebaeude/gwr-gebaeude-search-result/gwr-gebaeude-search-result.component';
import { GwrBauprojektSucheComponent } from './gwr-bauprojekt/gwr-bauprojekt-suche/gwr-bauprojekt-suche.component';
import { GwrBauprojektDetailComponent } from './gwr-bauprojekt/gwr-bauprojekt-detail/gwr-bauprojekt-detail.component';
import { GwrGebaeudeDetailComponent } from './gwr-gebaeude/gwr-gebaeude-detail/gwr-gebaeude-detail.component';
import { GwrWohnungDetailComponent } from './gwr-wohnung/gwr-wohnung-detail/gwr-wohnung-detail.component';
import { canActivateAuthorization } from '../security/authorization.guard';
import { canActivateErweiterung } from '../security/erweiterung.guard';
import { ErweiterungConfigResponse, PermissionResponse } from '../core/base-api';
import { GwrBauprojektSearchResultComponent } from './gwr-bauprojekt/gwr-bauprojekt-search-result/gwr-bauprojekt-search-result.component';
import { AppDeciderComponent } from '../layouts/app-decider/app-decider.component';
import { GwrBaujahrPeriodePipe } from './gwr-gebaeude/gwr-baujahr-periode-pipe';
import { GwrFormService } from './gwr-form.service';
import { GwrGrundstuecknummerPipe } from './gwr-grundstueck-list/gwr-grundstuecknummer.pipe';
import { KompaktGwrGebaeudeeingangsadressePipe } from './gwr-gebaeude/kompakt-gebaeudeeingangsadresse-pipe';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const GwrRoutes: Routes = [
  {
    path: 'gwr',
    component: AppDeciderComponent,
    canActivate: [canActivateAuthorization],
    data: {
      permissions: [PermissionsEnum.LOGIN]
    },
    children: [
      {
        path: '',
        loadChildren: () => routes,
        providers: [GwrBaujahrPeriodePipe, GwrFormService, GwrGrundstuecknummerPipe, KompaktGwrGebaeudeeingangsadressePipe]
      }
    ]
  }
];

const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: 'bauprojekte'
  },
  {
    path: 'bauprojekt',
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GWR_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.GWR_INTEGRATION]
    },
    component: GwrcontainerComponent,
    children: [
      {
        path: '',
        component: GwrBauprojektSucheComponent,
        data: {
          breadcrumb: 'gwrBauprojekt.BreadcrumbSuche',
          breadcrumbStatus: 'firstLevel'
        }
      },
      {
        path: 'list/:searchMode',
        component: GwrBauprojektSearchResultComponent,
        data: {
          breadcrumb: 'Suchergebnis',
          breadcrumbStatus: 'secondLevel'
        }
      },
      {
        path: 'detail/:eproid',
        component: GwrBauprojektDetailComponent,
        data: {
          origin: 'eproid'
        }
      },
      {
        path: 'detail',
        component: GwrBauprojektDetailComponent,
        data: {
          origin: 'dossiernummer'
        }
      }
    ]
  },
  {
    path: 'gebaeude',
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GWR_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.GWR_INTEGRATION]
    },
    children: [
      {
        path: '',
        component: GwrGebaeudeSucheComponent,
        data: {
          breadcrumb: 'gwrGebaeude.BreadcrumbSuche',
          breadcrumbStatus: 'firstLevel'
        }
      },
      {
        path: 'list/:searchMode',
        component: GwrGebaeudeSearchResultComponent,
        data: {
          breadcrumb: 'Suchergebnis',
          breadcrumbStatus: 'secondLevel'
        }
      },
      {
        path: 'detail/:egid',
        component: GwrGebaeudeDetailComponent
      },
      {
        path: 'detail/:egid/:ewid',
        component: GwrWohnungDetailComponent
      }
    ]
  }
];
